import {Injectable, Injector, inject} from "@angular/core";
import {EntityData, EntityModel, field, identifier} from "@fedelta-pos/data-client";

export class AuthorisedPaymentData extends EntityData<AuthorisedPaymentData> {
    @identifier paymentIntentId: string;
    @field integratedPaymentConfigId: number;
    @field platformLiveMode: boolean;
    @field amount: number;
    @field orderRequestId: string;
    @field storeId: number;
    @field firstName: string;
    @field lastName: string;
    @field email: string;
    @field phoneNumber: string;
    @field paymentCardBrand: string;
    @field paymentCardCountry: string;
    @field paymentCardLast4: string;
}

/**
 * Write-only entity model to save AuthorisedPaymentData
 */
@Injectable()
export class AuthorisedPaymentEntityModel extends EntityModel<AuthorisedPaymentData> {
    constructor() {
        console.log("--- AuthorisedPaymentEntityModel");
        super(inject(Injector), AuthorisedPaymentData);
    }
}
